// extracted by mini-css-extract-plugin
export var banner = "_s1-0";
export var settingRow = "_s1-2";
export var titleIcon = "_s1-1";